module.exports = __webpack_public_path__ + "static/media/UpIcon.dfef860a.svg";